import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_clients/tempula/')({
    component: () => <Navigate to="/tempula/home" replace />,
})
